import { Config } from '../constant/config.constant';

export const handleName = (product, className, mobile = false) => {
	if (product?.editable_name?.length > Config.lengthNameMobile && mobile === true) {
		return <h3 className={className}>{product.editable_name.substring(0, Config.lengthNameMobile) + '...'}</h3>;
	}
	if (product?.editable_name?.length > Config.lengthNameDesktop && mobile === false) {
		return <h3 className={className}>{product.editable_name.substring(0, Config.lengthNameDesktop) + '...'}</h3>;
	}

	return <h3 className={className}>{product.editable_name}</h3>;
};
